<template>
    <div class="workout-progress">
        <transition name="fade-fast">
            <Loader type="fullscreen" v-if="!firstDrillLoaded && !usemobile"></Loader>
        </transition>

        <Workout v-if="!usemobile && workout" :workout="workout" @firstDrillLoaded="hideLoader"></Workout>


        <div v-if="usemobile" :class="mobile_class" class="usemobile" id="usemobile_workout">
            <router-link :to="{ name: 'WorkoutOverview', params: { id: this.id } }">
                <div class="usemobile__back">
                    <Icon :name="'arrow-left'"></Icon>
                    <span v-translate>back</span>
                </div>
            </router-link>
            <div class="usemobile__inner">
                <img alt="PUMATRAC" src="../assets/trac-logo-light.svg" />
                <div class="usemobile__text" v-translate>best_experience_in_app</div>

                <puma-button @click="goToApp" title="Get it" type="light">
                    <translate>go_to_app</translate>
                </puma-button>

                <a @click.prevent="removeUsemobile"  href="javascript:void()" class="usemobile__browser">
                    <span v-translate>use_browser</span>
                </a>

            </div>
        </div>


    </div>
</template>

<script>
import * as api from '../api'
import Workout from "@/components/Workout.vue";
import router from '../router'
import store from '../store'
import { mapGetters } from "vuex"

import {addTrackingObject} from "@/utils/tracking"

export default {
    name: "WorkoutProgress",
    components: {
        Workout,
    },
    data () {
        return {
            ...mapGetters(['activeWorkout']),
            id: this.$route.params.id,
            workout: false,
            firstDrillLoaded: false,
            usemobile: false,
            mobile_class: '',
        }
    },
    mounted() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if(!this.activeWorkout() || (this.activeWorkout() && this.activeWorkout().id !== this.id)) {
            this.workout = this.activeWorkout()
        }

        if(/android/i.test(userAgent)) {
            this.mobile_class = "usemobile__android";
            this.usemobile = true;
        } else if (/iPhone|iPod/.test(userAgent) && !window.MSStream) {
            this.mobile_class = "usemobile__ios";
            this.usemobile = true;
        } else {
            if(!this.activeWorkout() || (this.activeWorkout() && this.activeWorkout().id !== this.id)) {
                this.fetchData()
            } else {
                 this.workout = this.activeWorkout()
            }
        }

        addTrackingObject({subSection: "home", screenName: "detailsWorkout"}, {type: "workout", value: "web_workout_player"});
    },
    methods: {
        async fetchData() {
            try {
                const response = await api.workout.get({id: this.id});
                this.workout = response.data.data
                store.commit('setActiveWorkout', this.workout)
            } catch (error) {
                console.error(error);
            }
        },
        hideLoader() {
            this.firstDrillLoaded = true;
        },
        goToApp() {
            router.push({ name: 'WorkoutOverview', params: { id: this.id } })
            window.open('https://share.pumatr.ac/workouts/' + this.id, '_blank');
        },
        removeUsemobile() {
            this.usemobile = false;
            if(!this.activeWorkout() || (this.activeWorkout() && this.activeWorkout().id !== this.id)) {
                this.fetchData()
            } else {
                 this.workout = this.activeWorkout()
            }
        }
    }
}
</script>

<style lang="scss">
.workout-progress {
    min-height: $fullheight;
    background: $puma-color-black;
}

.usemobile {
    position: fixed;
    z-index: 20;
    background: black;
    width: 100vw;
    height: $fullheight;
    top: 0;
    left: 0;
    box-sizing: border-box;

    &__ios,
    &__android {
        display: block;
    }

    &__inner {
        text-align: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    &__back {
        position: absolute;
        top: 40px;
        left: 40px;
        color: white;
        text-transform: uppercase;
        font-weight: $font-weight-bold;
        display: flex;
        align-items: center;
        z-index: 10;

        @include mq($until: notebook) {
            top: 25px;
        }

        @include mq($until: desktop) {
            top: $page-padding-small;
            left: $page-padding-small;
            font-size: $puma-size-font-xs;
        }

        .icon {
            margin-right: 16px;

            @include mq($until: desktop) {
                width: $page-padding-small;
                height: $page-padding-small;
           
            }
        }
    }

    &__text {
        padding: 15px 0 35px;
        color: white;
    }
    &__browser {
        position: relative;
        z-index: 10;
        cursor: pointer;
        display: block;
        padding-top: 20px;

        span {
            font-size: $puma-size-font-xs;
            color: white;
            text-decoration: underline;
        }
    }
}
</style>
